var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"container mt-5 mb-5"},[_c('Indicators')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }